import React from 'react'
import { Table, TableBody, TableHead, TableRow, Typography } from '@mui/material'
import useFavurTranslation from 'hooks/useFavurTranslation'
import { newDateWithoutTime } from 'utils/date'
import { CAPTION_SKELETON_TEST_ID } from './constants'
import { CaptionSkeleton, TableCell } from './styles'
import TableBodyCell from './table-body-cell'
import type { BalanceTableProps } from './types'
import { useBalanceTableContent } from './use-balance-table-content'
import { getFormattedValue } from './utils/get-formatted-value'

const BalanceTable: React.FC<BalanceTableProps> = ({ balance, isLoading, date = newDateWithoutTime() }) => {
  const { t } = useFavurTranslation()
  const { balanceRows, endDate, dateEndOfYear } = useBalanceTableContent({ date, balance })

  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell>
            <Typography variant="caption">{t('absenceRequest.components.employeeSaldo.endDate')}</Typography>
          </TableCell>
          <TableCell>
            <Typography variant="caption">{endDate}</Typography>
          </TableCell>
          <TableCell>
            {isLoading ? (
              <CaptionSkeleton data-testid={CAPTION_SKELETON_TEST_ID} />
            ) : (
              <Typography variant="caption">{dateEndOfYear}</Typography>
            )}
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {balanceRows.map((row) => (
          <TableRow key={row.title}>
            <TableBodyCell text={row.title} />
            <TableBodyCell text={getFormattedValue(row.value)} isLoading={isLoading} hideCell={row.value === null} />
            <TableBodyCell
              text={getFormattedValue(row.estimation)}
              isLoading={isLoading}
              hideCell={row.estimation === null}
            />
          </TableRow>
        ))}
      </TableBody>
    </Table>
  )
}

export default BalanceTable
